import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, first } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { BaseTokenService } from './base-token.service';
import { BaseLocalStorageService } from './base-local-storage.service';
import { BaseRolesService } from './base-roles.service';
import { BaseCoreState, baseAuthActions, baseAuthSelectors } from '../../_store';

@Injectable({ providedIn: 'root' })
export class AuthBootstrapService {
  constructor(
    private tokenService: BaseTokenService,
    private localStorageService: BaseLocalStorageService,
    private store: Store<BaseCoreState>,
    private rolesService: BaseRolesService
  ) {}

  initializeSession(): Promise<void> {
    const token = this.tokenService.getToken();
    if (!token) return Promise.resolve();

    if (this.tokenService.isValid(token)) {
      const decoded = this.tokenService.decodeToken(token);
      this.store.dispatch(baseAuthActions.setUserInfoFromToken({ payload: decoded }));
      this.rolesService.setRolesAndPermissions(decoded.roles, decoded.permissions);
      this.rolesService.setPermissions(decoded.permissions);
      this.store.dispatch(
        baseAuthActions.setFirstLoginIndicator({ payload: !this.localStorageService.get('login-id') })
      );
      this.store.dispatch(baseAuthActions.successUserInfo());
      this.store.dispatch(baseAuthActions.successRefreshUser());
      return Promise.resolve();
    } else {
      this.store.dispatch(baseAuthActions.refreshUser());

      return firstValueFrom(
        this.store.select(baseAuthSelectors.getRefreshInfo).pipe(
          filter((status) => status !== undefined),
          first()
        )
      ).then((status) => {
        if (status === false) {
          console.warn('Token refresh failed during bootstrap.');
        }
      });
    }
  }
}
